export const FirebaseConfig = {
	"projectId": "dispatch-speed-nigeria",
	"appId": "1:571010684316:web:8c30148f1b1833b1cce459",
	"databaseURL": "https://dispatch-speed-nigeria-default-rtdb.firebaseio.com",
	"storageBucket": "dispatch-speed-nigeria.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCZT4f4TCnw25kBT76a1o9xt3pJX9QzVcM",
	"authDomain": "dispatch-speed-nigeria.firebaseapp.com",
	"messagingSenderId": "571010684316",
	"measurementId": "G-6EZKGB8FVQ"
};